import axios, { AxiosPromise } from 'axios';

export default class LoginService {
  public login(loc = window.location) {
    const port = loc.port ? ':' + loc.port : '';
    let contextPath = location.pathname;
    if (contextPath.endsWith('accessdenied')) {
      contextPath = contextPath.substring(0, contextPath.indexOf('accessdenied'));
    }
    if (contextPath.endsWith('forbidden')) {
      contextPath = contextPath.substring(0, contextPath.indexOf('forbidden'));
    }
    if (contextPath.endsWith('not-found')) {
      contextPath = contextPath.substring(0, contextPath.indexOf('not-found'));
    }
    if (!contextPath.endsWith('/')) {
      contextPath = contextPath + '/';
    }
    if (!contextPath.indexOf('websocket')) {
      console.log('loc -> websocket websocket login');
    }

    // If you have configured multiple OIDC providers, then, you can update this URL to /login.
    // It will show a Spring Security generated login page with links to configured OIDC providers.
    loc.href = `//${loc.hostname}${port}${contextPath}oauth2/authorization/oidc`;
  }

  public logout(): AxiosPromise<any> {
    return axios.post('api/logout');
  }
  public changePassword(data?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`/api/employees/change-user-password`, { currentPassword: data.currentPassword, newPassword: data.newPassword })
        .then(res => {
          console.log(res, 'res');
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
